// import http, { expandURI } from '@/utils/ajax'
import { TTY_ACCT_INIT_LOADING, TTY_ACCT_INIT_SUCCESS, TTY_ACCT_INIT_FAIL, TTY_MASTER_INIT_LOADING, TTY_MASTER_INIT_SUCCESS, TTY_MASTER_INIT_FAIL } from '@/store/types'
// import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  [TTY_ACCT_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [TTY_ACCT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [TTY_ACCT_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [TTY_MASTER_INIT_LOADING](state) {
    state.treatyMaster.init = 0
    state.treatyMaster.initErr = []
    state.treatyMaster.menu = {}
  },
  [TTY_MASTER_INIT_SUCCESS](state, data) {
    state.treatyMaster.init = 1
    state.treatyMaster.initErr = []
    state.treatyMaster.menu = data.menu
  },
  [TTY_MASTER_INIT_FAIL](state, error) {
    state.treatyMaster.init = 2
    state.treatyMaster.initErr = error
    state.treatyMaster.menu = {}
  }
  // [TTY_STMT_LN](state, data) {
  //   state.ttyStmtLn = data
  // }
}
